import { render, staticRenderFns } from "./NoticeSection.vue?vue&type=template&id=05cbbe2c&scoped=true"
import script from "./NoticeSection.vue?vue&type=script&lang=js"
export * from "./NoticeSection.vue?vue&type=script&lang=js"
import style0 from "./NoticeSection.vue?vue&type=style&index=0&id=05cbbe2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cbbe2c",
  null
  
)

export default component.exports